import styled from 'styled-components';
import { greyText } from 'src/styles';

export const ValidityWrapper = styled.div`
  color: ${greyText};
`;
